<template>
  <el-dialog
    v-dialogDrag
    class="add-group-member-dialog im-dialog-shell im-dialog-shell--lg"
    title="邀请好友"
    :visible.sync="show"
    :width="dialogWidth"
    :before-close="close"
    custom-class="add-member-dialog"
    top="4vh"
    append-to-body
  >
    <div class="add-group-member" :class="{ 'is-mobile': isMobileView }">
      <div class="left-box">
        <div class="panel-head">
          <el-input placeholder="搜索好友昵称或完整账号" v-model="searchText" size="small" clearable>
            <i class="el-icon-search el-input__icon" slot="suffix"> </i>
          </el-input>
          <div class="select-tools">
            <el-checkbox
              v-model="allVisibleCheckedProxy"
              :indeterminate="isSelectAllIndeterminate"
              :disabled="invitableFriendTotalCount === 0"
            >
              全选
            </el-checkbox>
            <div class="select-tools__actions">
              <div class="result-badge">{{ invitableFriendTotalCount }}</div>
              <el-button
                type="text"
                icon="el-icon-delete"
                class="icon-btn clear-btn"
                :disabled="checkCount === 0"
                title="清空"
                @click="onClearChecked"
              ></el-button>
            </div>
          </div>
        </div>
        <empty-state
          v-if="showFriends.length === 0"
          class="scroll-box list-empty-state"
          icon="el-icon-search"
          :title="currentEmptyTitle"
          compact
        ></empty-state>
        <virtual-scroller
          v-else
          ref="friendScroller"
          class="scroll-box"
          :items="showFriends"
          :item-height="friendRowHeight"
          :item-key-getter="getSourceFriendKey"
          @reach-bottom="onFriendListReachBottom"
        >
          <template v-slot="{ item }">
            <friend-item @click.native="onSwitchCheck(item)" :menu="false" :friend="item" size="small">
              <el-checkbox
                :disabled="item.disabled"
                :value="item.isCheck"
                @input="setFriendChecked(item, $event)"
                @click.native.stop=""
                class="checkbox"
              ></el-checkbox>
            </friend-item>
          </template>
        </virtual-scroller>
      </div>
      <div class="right-box">
        <div class="panel-head selection-head">
          <div class="panel-title compact-title">
            <i class="el-icon-user-solid"></i>
            <span>已选成员</span>
            <span class="inline-count">{{ checkCount }}</span>
          </div>
          <el-button
            v-if="checkCount > 0"
            type="text"
            icon="el-icon-delete"
            class="icon-btn clear-btn"
            title="清空"
            @click="onClearChecked"
          ></el-button>
        </div>
        <empty-state
          v-if="checkedFriends.length === 0"
          class="scroll-box list-empty-state compact-empty"
          icon="el-icon-user"
          title="请选择要邀请的好友"
          compact
        ></empty-state>
        <virtual-scroller
          v-else
          class="scroll-box checked-scroll-box"
          :items="checkedFriendsView"
          :item-height="54"
          :item-key-getter="getCheckedFriendKey"
          @reach-bottom="onCheckedListReachBottom"
        >
          <template v-slot="{ item }">
            <div class="checked-item" @click="onRemoveFriend(item)">
              <head-image :url="item.headImage" :name="item.showNickName" :size="34"></head-image>
              <div class="checked-main">
                <div class="checked-name">{{ item.showNickName }}</div>
              </div>
              <div class="close" title="移除">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </template>
        </virtual-scroller>
      </div>
    </div>
    <span slot="footer" class="dialog-footer add-member-footer">
      <el-button @click="close()" :disabled="submitting">取 消</el-button>
      <el-button type="primary" @click="onOk()" :loading="submitting" :disabled="checkCount === 0 || submitting">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import FriendItem from '../friend/FriendItem.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import { attachContactSearchText, matchesContactKeyword } from '../../utils/contactSearchMatcher';

const CANDIDATE_PAGE_LIMIT = 30;
const CHECKED_RESULT_PAGE_SIZE = 30;

function resolveIdKey(id) {
  return id === undefined || id === null || id === '' ? '' : String(id);
}

function normalizeCandidatePage(payload) {
  const page = payload && typeof payload === 'object' ? payload : {};
  return {
    items: Array.isArray(page.items) ? page.items : [],
    cursor: page.cursor ? String(page.cursor) : '',
    more: Boolean(page.more),
    total: Math.max(0, Math.floor(Number(page.total || 0)))
  };
}

export default {
  name: "addGroupMember",
  components: {
    HeadImage,
    FriendItem,
    VirtualScroller
  },
  data() {
    return {
      show: false,
      searchText: "",
      friends: [],
      selectedMap: Object.create(null),
      selectedItems: Object.create(null),
      excludedMap: Object.create(null),
      allSelected: false,
      submitting: false,
      page: {
        cursor: '',
        more: false,
        total: 0,
        sourceTotal: 0,
        loading: false,
        loadingMore: false,
        keyword: ''
      },
      checkedViewLimit: CHECKED_RESULT_PAGE_SIZE,
      searchTimer: null,
      loadSeq: 0
    }
  },
  methods: {
    getSourceFriendKey(friend) {
      const key = resolveIdKey(friend && friend.id);
      return key ? `source:${key}` : '';
    },
    getCheckedFriendKey(friend) {
      const key = resolveIdKey(friend && friend.id);
      return key ? `checked:${key}` : '';
    },
    resetState() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.show = false;
      this.searchText = "";
      this.friends = [];
      this.selectedMap = Object.create(null);
      this.selectedItems = Object.create(null);
      this.excludedMap = Object.create(null);
      this.allSelected = false;
      this.submitting = false;
      this.page = {
        cursor: '',
        more: false,
        total: 0,
        sourceTotal: 0,
        loading: false,
        loadingMore: false,
        keyword: ''
      };
      this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
    },
    open() {
      this.resetState();
      this.show = true;
      this.loadCandidates({ reset: true });
    },
    close() {
      this.resetState();
    },
    async onOk() {
      if (this.submitting || this.checkCount === 0) {
        return;
      }
      const total = this.checkCount;
      const payload = this.buildSubmitPayload();
      this.submitting = true;
      try {
        await this.$http({
          url: "/group/invite",
          method: 'post',
          data: payload
        });
        this.$emit("reload");
        this.$message.success(`邀请成功，共${total}位好友`);
        this.close();
      } catch (error) {
        const failText = this.extractErrorMessage(error);
        this.$message.error(`邀请失败${failText ? `：${failText}` : ''}`);
      } finally {
        this.submitting = false;
      }
    },
    buildSubmitPayload() {
      if (this.allSelected) {
        return {
          groupId: this.groupId,
          selectionMode: 'ALL',
          excludedFriendIds: this.excludedFriendIds
        };
      }
      return {
        groupId: this.groupId,
        selectionMode: 'IDS',
        friendIds: this.selectedFriendIds
      };
    },
    onRemoveFriend(friend) {
      this.setFriendChecked(friend, false);
    },
    onSwitchCheck(friend) {
      this.setFriendChecked(friend, !this.isFriendChecked(friend));
    },
    setFriendChecked(friend, checked) {
      const key = resolveIdKey(friend && friend.id);
      if (!key || friend.disabled) {
        return;
      }
      if (this.allSelected) {
        if (checked) {
          this.$delete(this.excludedMap, key);
        } else {
          this.$set(this.excludedMap, key, Number(friend.id));
        }
      } else if (checked) {
        this.$set(this.selectedMap, key, Number(friend.id));
        this.$set(this.selectedItems, key, friend);
        if (this.selectedFriendIds.length <= this.checkedViewLimit + 1) {
          this.checkedViewLimit = this.selectedFriendIds.length;
        }
      } else {
        this.$delete(this.selectedMap, key);
        this.$delete(this.selectedItems, key);
      }
      friend.isCheck = this.isFriendChecked(friend);
    },
    isFriendChecked(friend) {
      const key = resolveIdKey(friend && friend.id);
      if (!key) {
        return false;
      }
      return this.allSelected ? !this.excludedMap[key] : Boolean(this.selectedMap[key]);
    },
    onClearChecked() {
      this.selectedMap = Object.create(null);
      this.selectedItems = Object.create(null);
      this.excludedMap = Object.create(null);
      this.allSelected = false;
      this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
      this.friends.forEach((friend) => {
        friend.isCheck = false;
      });
    },
    extractErrorMessage(error) {
      if (error && typeof error.message === "string" && error.message) {
        return error.message;
      }
      if (error && typeof error.msg === "string" && error.msg) {
        return error.msg;
      }
      if (error && error.response && error.response.data) {
        const responseData = error.response.data;
        if (typeof responseData === "string" && responseData) {
          return responseData;
        }
        if (typeof responseData.message === "string" && responseData.message) {
          return responseData.message;
        }
      }
      return "";
    },
    async onToggleGlobalSelectAll(checked) {
      if (checked) {
        await this.ensureSourceTotal();
      }
      this.selectedMap = Object.create(null);
      this.selectedItems = Object.create(null);
      this.excludedMap = Object.create(null);
      this.allSelected = Boolean(checked);
      this.friends.forEach((friend) => {
        friend.isCheck = this.allSelected;
      });
      if (this.allSelected) {
        this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
        await this.ensureCheckedWindowHydratedForAllSelected();
      }
    },
    async ensureSourceTotal() {
      if (this.page.sourceTotal > 0 || (!this.normalizedSearchText && this.page.total >= 0)) {
        if (!this.normalizedSearchText) {
          this.page.sourceTotal = Math.max(0, Math.floor(Number(this.page.total || 0)));
        }
        return this.page.sourceTotal;
      }
      if (this.canUseLocalCandidates()) {
        const page = this.buildLocalCandidatePage('');
        this.page.sourceTotal = page.total;
        return this.page.sourceTotal;
      }
      const params = new URLSearchParams();
      params.set('limit', '1');
      const page = await this.$http({
        url: `/group/${this.groupId}/member-candidates/invite?${params.toString()}`,
        method: 'get'
      }).then(normalizeCandidatePage);
      this.page.sourceTotal = page.total;
      return this.page.sourceTotal;
    },
    async loadCandidates({ reset = false } = {}) {
      if (!this.groupId) {
        this.friends = [];
        this.page.total = 0;
        return;
      }
      if (!reset && (!this.page.more || !this.page.cursor || this.page.loadingMore)) {
        return;
      }
      const seq = ++this.loadSeq;
      const keyword = this.normalizedSearchText;
      if (reset) {
        this.friends = [];
        this.page.cursor = '';
        this.page.more = false;
        this.page.total = 0;
        if (!keyword) {
          this.page.sourceTotal = 0;
        }
        this.page.keyword = keyword;
        this.page.loading = true;
      } else {
        this.page.loadingMore = true;
      }
      try {
        const page = await this.fetchCandidatePage({
          cursor: reset ? '' : this.page.cursor,
          keyword
        });
        if (seq !== this.loadSeq || !this.show) {
          return;
        }
        const items = page.items.map(friend => this.mapCandidateFriend(friend));
        this.friends = reset ? items : this.mergeFriendRows(this.friends, items);
        this.page.cursor = page.cursor;
        this.page.more = page.more;
        this.page.total = page.total;
        if (!keyword) {
          this.page.sourceTotal = page.total;
        }
        this.page.keyword = keyword;
      } catch (error) {
        console.warn('AddGroupMember 加载邀请候选失败', error);
        if (this.show) {
          this.$message.error('加载好友列表失败');
        }
      } finally {
        if (seq === this.loadSeq) {
          this.page.loading = false;
          this.page.loadingMore = false;
        }
      }
    },
    async fetchCandidatePage({ cursor = '', keyword = '' } = {}) {
      if (this.canUseLocalCandidates()) {
        return normalizeCandidatePage(this.buildLocalCandidatePage(keyword));
      }
      const params = new URLSearchParams();
      params.set('limit', String(CANDIDATE_PAGE_LIMIT));
      if (cursor) {
        params.set('cursor', cursor);
      }
      if (keyword) {
        params.set('keyword', keyword);
      }
      return this.$http({
        url: `/group/${this.groupId}/member-candidates/invite?${params.toString()}`,
        method: 'get'
      }).then(normalizeCandidatePage);
    },
    canUseLocalCandidates() {
      return this.friendStore.hasCompleteFriendSnapshot()
        && this.groupStore.hasCompleteMemberSnapshot
        && this.groupStore.hasCompleteMemberSnapshot(this.groupId);
    },
    buildLocalCandidatePage(keyword) {
      const memberIds = new Set();
      const group = this.groupStore.findGroup(this.groupId);
      ((group && group.members) || []).forEach((member) => {
        if (member && !member.quit && member.userId) {
          memberIds.add(String(member.userId));
        }
      });
      const normalizedKeyword = String(keyword || '').trim().toLowerCase();
      const items = this.friendStore.friends.filter((friend) => {
        if (!friend || friend.deleted || memberIds.has(String(friend.id))) {
          return false;
        }
        if (!normalizedKeyword) {
          return true;
        }
        return matchesContactKeyword(friend, normalizedKeyword);
      });
      return {
        items,
        cursor: '',
        more: false,
        total: items.length
      };
    },
    mapCandidateFriend(friend) {
      const item = attachContactSearchText({
        ...friend,
        disabled: false
      });
      item.isCheck = this.isFriendChecked(item);
      if (item.isCheck && !this.allSelected) {
        this.$set(this.selectedItems, String(item.id), item);
      }
      return item;
    },
    mergeFriendRows(oldRows, newRows) {
      const seen = new Set();
      const rows = [];
      oldRows.concat(newRows).forEach((friend) => {
        const key = resolveIdKey(friend && friend.id);
        if (!key || seen.has(key)) {
          return;
        }
        seen.add(key);
        friend.isCheck = this.isFriendChecked(friend);
        rows.push(friend);
      });
      return rows;
    },
    async ensureCheckedWindowHydratedForAllSelected() {
      if (!this.allSelected) {
        return;
      }
      const targetSize = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0));
      while (this.show && this.allSelected && this.checkedFriends.length < targetSize) {
        if (this.page.loading || this.page.loadingMore || !this.page.more || !this.page.cursor) {
          break;
        }
        const beforeLength = this.checkedFriends.length;
        const beforeCursor = this.page.cursor;
        await this.loadCandidates({ reset: false });
        if (this.checkedFriends.length <= beforeLength && this.page.cursor === beforeCursor) {
          break;
        }
      }
    },
    onFriendListReachBottom() {
      this.loadCandidates({ reset: false });
    },
    async onCheckedListReachBottom() {
      const nextLimit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0)) + CHECKED_RESULT_PAGE_SIZE;
      const maxCount = Math.max(this.checkCount, this.checkedFriends.length);
      this.checkedViewLimit = Math.min(maxCount, nextLimit);
      if (this.allSelected) {
        await this.ensureCheckedWindowHydratedForAllSelected();
      }
    }
  },
  props: {
    groupId: {
      type: Number
    },
    members: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isMobileView() {
      return this.configStore.isMobile;
    },
    dialogWidth() {
      return this.configStore.isMobile ? '100%' : '620px';
    },
    normalizedSearchText() {
      return String(this.searchText || '').trim();
    },
    friendRowHeight() {
      return 42;
    },
    showFriends() {
      return this.friends;
    },
    invitableFriendTotalCount() {
      return Math.max(0, Math.floor(Number(this.page.sourceTotal || this.page.total || 0)));
    },
    selectedFriendIds() {
      return Object.keys(this.selectedMap).map(key => Number(this.selectedMap[key])).filter(id => id > 0);
    },
    excludedFriendIds() {
      return Object.keys(this.excludedMap).map(key => Number(this.excludedMap[key])).filter(id => id > 0);
    },
    checkedFriends() {
      if (this.allSelected) {
        return this.friends.filter(friend => this.isFriendChecked(friend));
      }
      return Object.keys(this.selectedItems)
        .map(key => this.selectedItems[key])
        .filter(Boolean);
    },
    checkedFriendsView() {
      const limit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0));
      if (this.checkedFriends.length <= limit) {
        return this.checkedFriends;
      }
      return this.checkedFriends.slice(0, limit);
    },
    checkCount() {
      if (this.allSelected) {
        return Math.max(Math.max(0, Math.floor(Number(this.page.sourceTotal || this.page.total || 0))) - this.excludedFriendIds.length, 0);
      }
      return this.selectedFriendIds.length;
    },
    isAllVisibleChecked() {
      return this.invitableFriendTotalCount > 0 && this.checkCount === this.invitableFriendTotalCount;
    },
    isSelectAllIndeterminate() {
      return this.checkCount > 0 && this.checkCount < this.invitableFriendTotalCount;
    },
    allVisibleCheckedProxy: {
      get() {
        return this.isAllVisibleChecked;
      },
      set(checked) {
        this.onToggleGlobalSelectAll(checked);
      }
    },
    currentEmptyTitle() {
      if (this.page.loading) {
        return '加载中';
      }
      if (this.normalizedSearchText) {
        return '无结果';
      }
      return '暂无可选好友';
    }
  },
  watch: {
    searchText() {
      if (!this.show) {
        return;
      }
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.searchTimer = null;
        this.loadCandidates({ reset: true });
      }, 260);
    }
  }
}
</script>

<style lang="scss" scoped>
.add-group-member {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(196px, 220px);
  gap: 8px;
  height: min(416px, calc(100vh - 188px));
  min-height: 0;
  overflow: hidden;

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .panel-head {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 8px 10px 7px;
    border-bottom: 1px solid var(--im-surface-panel-border);
    flex-shrink: 0;
  }

  .panel-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--im-text-color);
    text-align: left;
  }

  .compact-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .result-badge,
  .inline-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    border-radius: 999px;
    background: rgba(var(--im-primary-rgb), 0.08);
    color: var(--im-color-primary);
    font-size: 12px;
    font-weight: 600;
  }

  .left-box,
  .right-box {
    overflow: hidden;
    border: 1px solid var(--im-surface-panel-border);
    border-radius: 8px;
    background: transparent;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .scroll-box {
    flex: 1;
    min-height: 0;
  }

  .select-tools {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 32px;

    .icon-btn {
      padding: 4px;
    }

    .clear-btn {
      color: var(--im-text-color-light);
    }
  }

  .select-tools__actions {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
  }

  .list-empty-state {
    height: 100%;
  }

  .left-box {
    .checkbox {
      margin-right: 10px;
    }

    ::v-deep .virtual-content {
      padding: 4px 0;
    }

    ::v-deep .friend-item {
      margin: 0 6px;
      border-radius: 6px;
    }
  }

  .right-box {
    .selection-head {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .compact-empty {
      padding: 18px 12px;
    }

    .checked-item {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 5px;
      padding: 7px 8px;
      border-radius: 6px;
      border: 1px solid var(--im-control-border);
      background: var(--im-control-soft-bg);
      cursor: pointer;
      transition: background-color 0.2s ease, border-color 0.2s ease;

      .checked-main {
        flex: 1;
        min-width: 0;
        text-align: left;
      }

      .checked-name {
        font-size: var(--im-font-size);
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .close {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        border-radius: 6px;
        color: var(--im-text-color-light);
        flex-shrink: 0;
        transition: background-color 0.2s ease, color 0.2s ease;
      }

      &:hover {
        background: rgba(var(--im-primary-rgb), 0.05);
        border-color: rgba(var(--im-primary-rgb), 0.12);

        .close {
          background: rgba(var(--im-primary-rgb), 0.12);
          color: var(--im-text-color);
        }
      }
    }
  }

  &.is-mobile {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, 1fr) auto;
    gap: 8px;
    height: min(560px, calc(100vh - 232px));

    .left-box,
    .right-box {
      border-radius: 8px;
    }

    .right-box {
      min-height: 96px;

      .scroll-box {
        min-height: 64px;
        max-height: 82px;
      }

      ::v-deep .virtual-scroller {
        overflow-x: auto;
        overflow-y: hidden;
      }

      ::v-deep .virtual-content {
        display: flex;
        gap: 8px;
        min-width: 100%;
        padding: 0 2px;
      }

      .checked-item {
        flex: 0 0 156px;
        margin: 5px 0;
      }
    }
  }
}

.add-group-member-dialog {
  ::v-deep .add-member-dialog {
    max-height: calc(100vh - 24px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: min(680px, calc(100vw - 24px)) !important;
    border-radius: 8px;
    border: 1px solid var(--im-surface-panel-border);
    box-shadow: 0 14px 30px -22px rgba(var(--im-black-rgb), 0.34);
  }

  ::v-deep .el-dialog__body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 10px 16px 12px;
  }

  ::v-deep .el-dialog__footer {
    flex-shrink: 0;
    padding: 10px 16px 16px;
    border-top: 1px solid var(--im-surface-panel-border);
  }
}

@media (max-width: 640px) {
  .add-group-member-dialog {
    display: flex;
    align-items: flex-end;
    padding: 0;
    overflow: hidden;

    ::v-deep .add-member-dialog {
      width: calc(100vw - 12px) !important;
      max-height: min(720px, calc(100vh - 72px));
      margin: 0 auto 6px !important;
      border-radius: 8px 8px 0 0;
    }

    ::v-deep .el-dialog__body {
      padding: 8px 12px 10px;
    }

    ::v-deep .el-dialog__footer {
      padding: 8px 12px calc(10px + env(safe-area-inset-bottom));
    }
  }

  .add-member-footer {
    display: grid;
    grid-template-columns: 92px minmax(0, 1fr);
    gap: 8px;
    width: 100%;
  }
}
</style>
